import * as React from 'react'
import { getOAuthInfo, goToSignIn, loadProfileAndUpdate, selectors } from '../../lifecycle/auth'
import { connect } from 'react-redux'
import { IProps } from './types'
import { UnauthorizedModal } from '@mulesoft/design-center-components'
import { AppState, Dispatch } from '../../types'

type EnhancedIProps = IProps & {
  signInRequired?: () => void
}

const checkAuthState = ({isUnauthorized, signInRequired}: EnhancedIProps) => {
  if (isUnauthorized && signInRequired) {
    signInRequired()
  }
}

class EnhancedUnauthorizedModal extends React.Component<EnhancedIProps> {

  componentWillReceiveProps(nextProps: EnhancedIProps) {
    checkAuthState(nextProps)
  }

  render() {
    return <UnauthorizedModal {...this.props}/>
  }
}

const mapState = (rootState: AppState): EnhancedIProps => {
  const {loginUrl} = getOAuthInfo()

  const authorization = selectors.getAuthorization(rootState)
  const checkingProfile = selectors.isCheckingProfile(rootState)
  const requiresProfile = selectors.requiresProfile(rootState)
  const profileLoaded = selectors.isProfileLoaded(rootState)
  const profileLoading = selectors.isProfileLoading(rootState)
  const isLoggedIn = !!authorization
  const isUnauthorized = !checkingProfile && requiresProfile && (!profileLoaded || profileLoading)

  return {isLoggedIn, isUnauthorized, loginUrl}
}

const mapDispatch = (dispatch: Dispatch): EnhancedIProps => ({
  onNewAccessToken: (accessToken: string) => dispatch(loadProfileAndUpdate(accessToken)),
  signInRequired: () => goToSignIn()
})

export default connect(mapState, mapDispatch)(EnhancedUnauthorizedModal)
